export const ConnectionUrl = {
    github: 'https://github.com/typinghare'
} as const
